"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Mail, Phone } from "lucide-react";
export default function AboutJordan() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="about-jordan" ref={ref} className="relative py-20 overflow-hidden !bg-[hsl(215,20%,65%)] !opacity-[1] !text-[hsl(0,0%,100%)]">
      <div className="container mx-auto px-4 max-w-7xl">
        {}
        <div className={`text-center mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-4">
            Meet the Crew
          </h2>
          <p className="text-lg text-foreground/90 leading-relaxed max-w-3xl mx-auto">
            Our experienced team brings passion, expertise, and years of experience to make your special day unforgettable.
          </p>
        </div>

        {}
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
          {}
          <div className="space-y-6">
            <div className={`relative overflow-hidden rounded-lg shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: isVisible ? "150ms" : "0ms"
          }}>
              <div className="group relative aspect-[3/4] overflow-hidden rounded-lg">
                <img src="https://denverweddingco.com/wp-content/uploads/2026/01/Screenshot-2026-01-30-at-10.17.30-AM.png" alt="Jordan Ebner - Denver Wedding DJ" className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
              </div>
            </div>

            <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: isVisible ? "300ms" : "0ms"
          }}>
              <h3 className="text-2xl md:text-3xl font-display font-bold text-foreground mb-2">
                Jordan Ebner
              </h3>
              <p className="text-lg text-primary-dark font-medium mb-4">DJ &amp; AV Specialist</p>
              <p className="text-foreground/90 leading-relaxed">
                A seasoned Denver-based wedding DJ and AV specialist who brings years of experience to every celebration. Jordan's passion lies in transforming special moments into unforgettable experiences through expertly curated music, professional sound engineering, and dynamic lighting design.
              </p>
            </div>

            
          </div>

          {}
          <div className="space-y-6">
            <div className={`relative overflow-hidden rounded-lg shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: isVisible ? "200ms" : "0ms"
          }}>
              <div className="group relative aspect-[3/4] overflow-hidden rounded-lg">
                <img src="https://denverweddingco.com/wp-content/uploads/2026/01/Screenshot-2026-01-30-at-10.08.00-AM.png" alt="Kenzie Hull - Event Coordinator" className="w-full h-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
              </div>
            </div>

            <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: isVisible ? "350ms" : "0ms"
          }}>
              <h3 className="text-2xl md:text-3xl font-display font-bold text-foreground mb-2">
                Kenzie Hull
              </h3>
              <p className="text-lg text-primary-dark font-medium mb-4">
                Event Coordinator
              </p>
              <p className="text-foreground/90 leading-relaxed">
                Kenzie brings exceptional organizational skills and attention to detail to every event. With a keen eye for creating seamless experiences, she ensures that every element comes together perfectly to bring your vision to life.
              </p>
            </div>

            
          </div>
        </div>

        {}
        <div className="mt-16">
          <Card className={`bg-background/10 backdrop-blur-sm border border-muted/20 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:shadow-medium ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: isVisible ? "600ms" : "0ms"
        }}>
            <div className="px-6 py-6">
              <h3 className="text-2xl font-display font-bold text-foreground mb-6 text-center">
                Get in Touch
              </h3>
              <div className="flex flex-col md:flex-row items-center justify-center gap-8">
                <Link to="mailto:denverweddingco@gmail.com" className="flex items-center gap-3 text-foreground/90 hover:text-primary-dark transition-colors duration-[var(--duration-fast)] group">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors duration-[var(--duration-fast)]">
                    <Mail className="w-6 h-6 text-primary-dark" />
                  </div>
                  <span className="text-lg font-medium">denverweddingco@gmail.com</span>
                </Link>
                <Link to="tel:720-289-4986" className="flex items-center gap-3 text-foreground/90 hover:text-primary-dark transition-colors duration-[var(--duration-fast)] group">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors duration-[var(--duration-fast)]">
                    <Phone className="w-6 h-6 text-primary-dark" />
                  </div>
                  <span className="text-lg font-medium">720-289-4986</span>
                </Link>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}